import '../assets/scss/app.scss';

import { useEffect } from 'react';
import { useAppSelector } from 'store';

import { PageLayout } from './layout/page-layout/page-layout';

const App = () => {
  const isModalOpen = useAppSelector((state) =>
    state.modals.some((modal) => modal.isOpen),
  );

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  return <PageLayout />;
};

export default App;
